import React from 'react'
import './styles/index.css'


const Thumb = ({ imageUrl, alt, listId }) => {
  if (!imageUrl || imageUrl === '') return null

  return (
    <div className="image-wrapper">
      <img className="thumbnail" src={imageUrl} alt={alt} />
    </div>
  )
}

export default Thumb



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/MobileCarousel/Thumb.js